export const TEXT_LESSON_COMPLETE = 'Lesson Complete'
export const TEXT_MARK_LESSON_DONE = 'MARK LESSON DONE'
